<template>
  <section class="co-surface co-bvh">
    <div class="co-section-head co-bvh__head">
      <div>
        <h2 class="co-section-title">
          Bot vs atendimento humano
        </h2>
        <p class="co-section-desc">
          Evolução por hora do dia (início do atendimento) no período selecionado.
        </p>
      </div>
    </div>
    <div class="co-bvh__chart">
      <vue-apex-chart
        type="area"
        height="320"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </section>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'CentralBotVsHumanSection',
  components: {
    'vue-apex-chart': VueApexCharts,
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    seriesTotal: {
      type: Array,
      default: () => [],
    },
    seriesHuman: {
      type: Array,
      default: () => [],
    },
    seriesBot: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return [
        { name: 'Total', data: this.seriesTotal },
        { name: 'Humano', data: this.seriesHuman },
        { name: 'Bot', data: this.seriesBot },
      ]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          fontFamily: 'inherit',
          zoom: { enabled: false },
        },
        colors: ['#b39ddb', '#5e35b1', '#ff6f61'],
        stroke: {
          curve: 'smooth',
          width: [2, 2, 2],
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0.35,
            opacityFrom: 0.35,
            opacityTo: 0.05,
          },
        },
        dataLabels: { enabled: false },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          fontWeight: 600,
          markers: { width: 10, height: 10, radius: 3 },
        },
        grid: {
          borderColor: '#eceff1',
          strokeDashArray: 4,
          padding: { left: 8, right: 8 },
        },
        xaxis: {
          categories: this.categories,
          labels: { style: { colors: '#757575', fontSize: '11px', fontWeight: 500 } },
          axisBorder: { show: false },
        },
        yaxis: {
          labels: {
            style: { colors: '#757575', fontSize: '11px' },
          },
          title: {
            text: 'Atendimentos',
            style: { color: '#9e9e9e', fontSize: '11px', fontWeight: 600 },
          },
        },
        tooltip: {
          shared: true,
          y: {
            formatter: val => `${val} atend.`,
          },
        },
      }
    },
  },
}
</script>

<style scoped>
.co-surface {
  background: #faf8fc;
  border-radius: 24px;
  padding: 1.75rem 1.5rem 1.25rem;
  border: 1px solid rgba(106, 27, 154, 0.08);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.co-section-head {
  margin-bottom: 0.5rem;
}

.co-section-title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 800;
  color: #4a148c;
  letter-spacing: -0.02em;
}

.co-section-desc {
  margin: 0;
  font-size: 0.9rem;
  color: #616161;
  max-width: 640px;
  line-height: 1.5;
}

.co-bvh__chart {
  margin-top: 0.5rem;
  background: #fff;
  border-radius: 16px;
  padding: 0.5rem 0.25rem 0;
  border: 1px solid rgba(0, 0, 0, 0.04);
}
</style>
